import React from "react";

import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import { styles } from "./styles";

export interface SelectOption {
  label: string;
  value: string;
  bgColor?: string;
  textColor?: string;
}

interface PillSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  options: SelectOption[];
}

export function PillSelect(props: PillSelectProps) {
  const { value, onChange, disabled, options } = props;

  const selectedOption = options.find((o) => o.value === value);

  const bgColor = selectedOption?.bgColor ?? "grey300";
  const textColor = selectedOption?.textColor ?? "grey800";

  const handleChange = (e: SelectChangeEvent<string>) =>
    onChange(e.target.value);

  return (
    <Select<string>
      value={value}
      onChange={handleChange}
      disabled={disabled}
      size="small"
      variant="outlined"
      renderValue={() => selectedOption?.label ?? value}
      sx={styles.pillSelect(bgColor, textColor)}
      MenuProps={{
        PaperProps: { sx: styles.pillSelectMenu },
        MenuListProps: { sx: { py: 0.5 } },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{ fontSize: 14, py: 0.75, px: 1.5 }}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
}
